import { render, staticRenderFns } from "./InputHotel.vue?vue&type=template&id=5a2cf91c&scoped=true"
import script from "./InputHotel.vue?vue&type=script&lang=js"
export * from "./InputHotel.vue?vue&type=script&lang=js"
import style0 from "./InputHotel.vue?vue&type=style&index=0&id=5a2cf91c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2cf91c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconsFlight: require('/home/forge/ab.farescraper.com/components/IconsFlight.vue').default,IconsHotel: require('/home/forge/ab.farescraper.com/components/IconsHotel.vue').default,IconsCity: require('/home/forge/ab.farescraper.com/components/IconsCity.vue').default})
